export default function prepareJSONExport(contentToExport, content) {
  contentToExport = JSON.parse(JSON.stringify(content));

  // Groups
  let groups = contentToExport.groepen.groep;
  if (groups && Array.isArray(groups)) {
    groups.forEach((group) => {
      if (group && group.jaargroep) {
        // Check if jaargroep is an object with a key property
        if (typeof group.jaargroep === 'object' && group.jaargroep.key !== undefined) {
          let tempYearGroup = group.jaargroep.key;
          group.jaargroep = tempYearGroup;
        }
        // If jaargroep is already a primitive value, leave it as is
      }
    });
  }

  // Teachers
  let teachers = contentToExport.leerkrachten.leerkracht;
  teachers.forEach((teacher) => {
    if (teacher.groepen && teacher.groepen.groep && Array.isArray(teacher.groepen.groep)) {
      teacher.groepen.groep.forEach((teacherGroup) => {
        if (teacherGroup && typeof teacherGroup === 'object') {
          delete teacherGroup.naam;
          delete teacherGroup.jaargroep;
          delete teacherGroup.omschrijving;
        }
      });
    }
    if (teacher.groepen && teacher.groepen.samengestelde_groep && teacher.groepen.samengestelde_groep !== undefined) {
      if (!Array.isArray(teacher.groepen.samengestelde_groep)) {
        if (teacher.groepen.samengestelde_groep && typeof teacher.groepen.samengestelde_groep === 'object') {
          delete teacher.groepen.samengestelde_groep.naam;
          delete teacher.groepen.samengestelde_groep.omschrijving;
        }
      } else {
        teacher.groepen.samengestelde_groep.forEach((group) => {
          if (group && typeof group === 'object') {
            if (group.key && group.key.key) {
              const tempKey = group.key.key;
              group.key = {};
              group.key.key = tempKey;
            }
            delete group.naam;
            delete group.omschrijving;
          }
        });
      }
      const tempComposedGroup = teacher.groepen.samengestelde_groep;
      teacher.samengestelde_groep = tempComposedGroup;
    }
  });

  //Pupils
  let pupils = contentToExport.leerlingen.leerling;
  if (pupils && Array.isArray(pupils)) {
    pupils.forEach((pupil) => {
      if (pupil && typeof pupil === 'object') {
        if (pupil.voorvoorvoegsel) pupil.toevoegingen = "";

        // Handle jaargroep before cleaning up the group
        if (pupil.jaargroep !== undefined && pupil.jaargroep !== null) {
          // Check if jaargroep is an object with a key property
          if (typeof pupil.jaargroep === 'object' && pupil.jaargroep.key !== undefined) {
            pupil.jaargroep = pupil.jaargroep.key;
          }
          // If jaargroep is already a primitive value, leave it as is
        }

        if (pupil.groep && typeof pupil.groep === 'object') {
          delete pupil.groep.jaargroep;
          delete pupil.groep.naam;
          delete pupil.groep.omschrijving;
        }

        if (pupil.geslacht && pupil.geslacht.key) {
          pupil.geslacht = pupil.geslacht.key;
        }
        if (pupil.samengestelde_groepen && pupil.samengestelde_groepen !== undefined) {
          if (pupil.samengestelde_groepen.samengestelde_groep !== null) {
            if (!Array.isArray(pupil.samengestelde_groepen.samengestelde_groep)) {
              if (pupil.samengestelde_groepen.samengestelde_groep && typeof pupil.samengestelde_groepen.samengestelde_groep === 'object') {
                delete pupil.samengestelde_groepen.samengestelde_groep.naam;
                delete pupil.samengestelde_groepen.samengestelde_groep.omschrijving;
              }
            } else {
              pupil.samengestelde_groepen.samengestelde_groep.forEach((group) => {
                if (group && typeof group === 'object') {
                  delete group.naam;
                  delete group.omschrijving;
                }
              });
            }
          }
        }
      }
    });
  }

  return contentToExport;
}
